import { ItemProps } from 'interface/menu/menuInfo';
import { BiDetail, BiDockTop, BiCubeAlt } from 'react-icons/bi';

const menuIcons = {
  BiDetail,
  BiDockTop,
  BiCubeAlt,
};
const management: ItemProps = {
  id: 'admin',
  title: '',
  type: 'group',
  children: [
    {
      id: 'project',
      title: '프로젝트',
      type: 'collapse',
      url: '/admin/project',
      icon: menuIcons.BiDetail,
      children: [
        {
          id: 'project',
          title: '프로젝트 진행상황',
          type: 'item',
          url: '/admin/project/overview',
        },
        {
          id: 'create',
          title: '프로젝트 생성(유형 선택)',
          type: 'item',
          url: '/admin/project/create',
        },
      ],
    },
    {
      id: 'member-management',
      title: '회원 관리',
      type: 'item',
      url: '/admin/member-management',
      icon: menuIcons.BiDockTop,
    },
    {
      id: 'diagnostic-management',
      title: '진단 관리',
      type: 'item',
      url: '/admin/diagnostic-management',
      icon: menuIcons.BiCubeAlt,
    },
  ],
};

export default management;
